import reduxFetch from 'react-redux-fetch';
import apiRoutes from '../../../app/api/routes';
import { REMOVE_APP_RESOURCE, APPS_RESOURCE } from '../constants';
import { createErrorMessage } from '../../app/helpers/createErrorMessage';

const RemoveAppService = ComposedComponent =>
  reduxFetch([
    {
      resource: REMOVE_APP_RESOURCE,
      method: 'delete',
      request: (appId, callback, t) => ({
        url: apiRoutes.apps(appId),
        meta: {
          callback,
          removeFromOtherList: {
            resource: APPS_RESOURCE,
            idProp: 'id',
            id: appId,
          },
          toaster: {
            onErrorMessage: createErrorMessage(t, 'removeAppFailed'),
            onSuccessMessage: t('removeAppSuccess'),
          },
        },
      }),
    },
  ])(ComposedComponent);

export default RemoveAppService;
